import { reactive } from 'vue'

export default reactive<any>({
  auth: false,
  user: {},
})
